import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const OnlineAd: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30.0984 29.0739C30.0984 27.8133 31.1272 26.7878 32.3918 26.7878C33.0112 26.7878 33.5926 27.0379 34.0288 27.492L36.9209 30.5027H41.2797V7.14062H6.71436V30.5027H30.0984V29.0739Z"
      fill="white"
    />
    <path
      d="M37.2624 26.81H23.9806C23.1782 26.81 22.5278 26.1596 22.5278 25.3572V16.3595C22.5278 15.5571 23.1782 14.9067 23.9806 14.9067H37.2624C38.0648 14.9067 38.7152 15.5571 38.7152 16.3595V25.3572C38.7152 26.1596 38.0648 26.81 37.2624 26.81Z"
      fill="#FF612B"
    />
    <path
      d="M19.8784 16.9951H10.5708C10.0186 16.9951 9.5708 16.5473 9.5708 15.9951C9.5708 15.4429 10.0186 14.9951 10.5708 14.9951H19.8784C20.4306 14.9951 20.8784 15.4429 20.8784 15.9951C20.8784 16.5473 20.4307 16.9951 19.8784 16.9951Z"
      fill="#002677"
    />
    <path
      d="M19.8784 21.7725H10.5708C10.0186 21.7725 9.5708 21.3247 9.5708 20.7725C9.5708 20.2203 10.0186 19.7725 10.5708 19.7725H19.8784C20.4306 19.7725 20.8784 20.2203 20.8784 20.7725C20.8784 21.3247 20.4307 21.7725 19.8784 21.7725Z"
      fill="#002677"
    />
    <path
      d="M19.8784 26.5498H10.5708C10.0186 26.5498 9.5708 26.1025 9.5708 25.5498C9.5708 24.9976 10.0186 24.5498 10.5708 24.5498H19.8784C20.4306 24.5498 20.8784 24.9976 20.8784 25.5498C20.8784 26.1025 20.4307 26.5498 19.8784 26.5498Z"
      fill="#002677"
    />
    <path
      d="M40.2862 35.4499L33.3073 28.1848C33.0438 27.9105 32.7146 27.7878 32.3915 27.7878C31.7323 27.7878 31.0981 28.2982 31.0981 29.0739V38.9585C31.0981 39.7385 31.7346 40.2446 32.3926 40.2446C32.7323 40.2446 33.0777 40.1096 33.3441 39.8077L34.8328 38.1205L37.2366 42.4131C37.4707 42.831 37.906 43.0697 38.3573 43.0697C38.5404 43.0697 38.7263 43.0303 38.9022 42.9477C39.5831 42.6279 39.8443 41.7938 39.4674 41.1428L37.4293 37.6225H39.3605C40.4917 37.6226 41.0698 36.2656 40.2862 35.4499Z"
      fill="#002677"
    />
    <path
      d="M43.4904 6.78883C43.4904 6.14713 43.1653 5.58153 42.6708 5.24743C42.3741 5.04703 42.0164 4.92993 41.6314 4.92993H6.36242C5.97742 4.92993 5.61972 5.04703 5.32302 5.24743C4.82862 5.58143 4.50342 6.14713 4.50342 6.78883V11.2478L4.50352 30.8546C4.50352 31.8812 5.33572 32.7135 6.36242 32.7135H30.0983V30.5027H6.71432V11.2479H41.2797V30.5028H36.9209L39.0446 32.7136H41.6316C42.6583 32.7136 43.4905 31.8813 43.4905 30.8547V11.2479L43.4904 6.78883Z"
      fill="#002677"
    />
    <path
      d="M8.28896 9.6636C9.15858 9.6636 9.86356 8.95863 9.86356 8.089C9.86356 7.21938 9.15858 6.5144 8.28896 6.5144C7.41933 6.5144 6.71436 7.21938 6.71436 8.089C6.71436 8.95863 7.41933 9.6636 8.28896 9.6636Z"
      fill="white"
    />
    <path
      d="M13.0419 9.6636C13.9115 9.6636 14.6165 8.95863 14.6165 8.089C14.6165 7.21938 13.9115 6.5144 13.0419 6.5144C12.1723 6.5144 11.4673 7.21938 11.4673 8.089C11.4673 8.95863 12.1723 9.6636 13.0419 9.6636Z"
      fill="white"
    />
    <path
      d="M17.7953 9.6636C18.6649 9.6636 19.3699 8.95863 19.3699 8.089C19.3699 7.21938 18.6649 6.5144 17.7953 6.5144C16.9257 6.5144 16.2207 7.21938 16.2207 8.089C16.2207 8.95863 16.9257 9.6636 17.7953 9.6636Z"
      fill="white"
    />
  </Box>
)
export default OnlineAd
